import { isFeatureEnabled } from 'owa-feature-flags';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export default function getCalendarBarIconColor(colorScheme: ColorScheme): string {
    return isHostAppFeatureEnabled('reduceCalBarExp') &&
        isFeatureEnabled('cal-mf-reduceCalendarBar')
        ? colorScheme.accessibleText.msColorWhiteBackground
        : colorScheme.accessibleText.calPrimaryBackground;
}
